export const iconFontAwesomeSciencefictionSpaceAwesome = (
	<i className="fa-solid fa-space-awesome"></i>
);
